import { userApi } from '../redux/api/axiosInstance';

export interface HRLocalization {
  defaultCurrency: string;
  defaultPayrollFrequency: string;
  fiscalYearStart: string;
}

export interface HRFieldDefinition {
  fieldKey: string;
  label: string;
  fieldType: 'text' | 'date' | 'select' | 'number' | 'toggle' | 'file';
  isRequired?: boolean;
  validationPattern?: string | null;
  selectOptions?: string[];
  groupName?: string;
  displayOrder: number;
  condition?: {
    fieldKey: string;
    value: string;
  };
}

export interface FieldValue {
  fieldKey: string;
  fieldValue: string;
  updatedAt: string;
}

export const getLocalization = async (countryCode?: string): Promise<HRLocalization> => {
  const params = countryCode ? `?countryCode=${countryCode}` : '';
  const { data } = await userApi.get(`country-metadata/localization${params}`);
  return data;
};

export const getEmployeeFields = async (countryCode?: string): Promise<HRFieldDefinition[]> => {
  const params = countryCode ? `?countryCode=${countryCode}` : '';
  const { data } = await userApi.get(`country-metadata/employee-fields${params}`);
  return data;
};

export const getOrgFields = async (countryCode?: string): Promise<HRFieldDefinition[]> => {
  const params = countryCode ? `?countryCode=${countryCode}` : '';
  const { data } = await userApi.get(`country-metadata/org-fields${params}`);
  return data;
};

export const getEmployeeFieldValues = async (employeeId: number): Promise<FieldValue[]> => {
  const { data } = await userApi.get(`country-field-values/employee/${employeeId}`);
  return data;
};

export const saveEmployeeFieldValues = async (
  employeeId: number,
  values: Record<string, string>,
): Promise<void> => {
  await userApi.put(`country-field-values/employee/${employeeId}`, values);
};

export const getOrgFieldValues = async (orgId: number): Promise<FieldValue[]> => {
  const { data } = await userApi.get(`country-field-values/org/${orgId}`);
  return data;
};

export const saveOrgFieldValues = async (
  orgId: number,
  values: Record<string, string>,
): Promise<void> => {
  await userApi.put(`country-field-values/org/${orgId}`, values);
};
